export default __webpack_public_path__ + "static/media/social_btn_right.a104ffb0.svg";